// A link to a section of the home page, from anywhere on the site.
//
// The header and the footer used to sit on one page only, so `#visit` was
// always enough — the browser scrolled and nothing navigated. Now they also sit
// on /wholesale, where `#visit` points at a section that is not there and the
// link does nothing at all. From off the home page the same label has to
// travel: `/#visit` goes home first, and src/router/index.ts takes it the rest
// of the way to the section once React has rendered it.
//
// On the home page itself this stays the plain anchor it has always been.

import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

export default function SectionLink({
  hash,
  className,
  onClick,
  children,
}: {
  /** The section, with its hash — "#visit". */
  hash: string;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}) {
  const onHome = useLocation().pathname === "/";

  if (onHome) {
    return (
      <a href={hash} className={className} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <Link to={`/${hash}`} className={className} onClick={onClick}>
      {children}
    </Link>
  );
}
